import { useEffect, useSyncExternalStore } from "react";

/**
 * The tail of the Top bar's crumb: «Кампании / RO_Mirvoactive_wide_25+_v3».
 *
 * The Top bar knows WHERE you are from the path; only the screen knows the
 * name of the thing it shows. A detail screen states it with `useCrumbTail`,
 * and the tail clears itself when the screen unmounts, so a stale name can
 * never ride onto the next page.
 */
let tail = "";
const listeners = new Set<() => void>();

function set(next: string): void {
  if (next === tail) return;
  tail = next;
  for (const l of listeners) l();
}

function subscribe(onChange: () => void): () => void {
  listeners.add(onChange);
  return () => listeners.delete(onChange);
}

const read = () => tail;

/** The current tail ("" = none). */
export function useCrumbTailValue(): string {
  return useSyncExternalStore(subscribe, read, read);
}

/** Names the object this screen is about, for as long as it is on screen. */
export function useCrumbTail(name: string | undefined): void {
  useEffect(() => {
    set(name ?? "");
    return () => set("");
  }, [name]);
}
